export const INIT_APPLICATION = 'INIT_APPLICATION';
export const INIT_APPLICATION_SUCCESS = 'INIT_APPLICATION_SUCCESS';
export const INIT_APPLICATION_FAILURE = 'INIT_APPLICATION_FAILURE';

export const initApplication = () => ({
  type: INIT_APPLICATION
});

export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const refreshToken = provisionalToken => ({
  type: REFRESH_TOKEN,
  payload: provisionalToken
});

export const SWITCH_ACCOUNT_TYPE = 'SWITCH_ACCOUNT_TYPE';
export const SWITCH_ACCOUNT_TYPE_SUCCESS = 'SWITCH_ACCOUNT_TYPE_SUCCESS';
export const switchAccountType = (token, accountType) => ({
  type: SWITCH_ACCOUNT_TYPE,
  payload: { token, accountType }
});
